import 'css-chunksrc/client/scenes/constraintEdition/constrainedElement/element/event/styles.scss';export default {
  "event": "_event_i2286_1",
  "element": "_element_i2286_7",
  "icon": "_icon_i2286_12"
};